export default __webpack_public_path__ + "static/media/JoinPL.87a10a3e.png";